import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { StorageService } from '../services/storage.service';
import { SKIP_AUTH } from './auth-context';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const storage = inject(StorageService);
  const token = storage.getToken();

  if (req.context.get(SKIP_AUTH)) {
    return next(req.clone({ withCredentials: true }));
  }

  if (token) {
    const cloned = req.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
      withCredentials: true,
    });
    return next(cloned);
  }

  return next(req.clone({ withCredentials: true }));
};
